module.exports = __webpack_public_path__ + "img/Trustor-rule.c8bd93da.png";